import * as React from "react";
import {Col, Row} from "react-bootstrap";
import "./styles/header.less";

// tslint:disable-next-line
// const headerHtml = require("../html/parksavers_header.html");

export const Header: React.SFC<{}> = (props: {}) => {
    return  (<Row style={{marginTop: "35px"}}>
        <Col xs={0} lg={1}/>
        <Col xs={12} lg={10}><div /></Col>
        <Col xs={0} lg={1}/>
    </Row>);
};


// tslint:disable-next-line
// const footerHtml = require("../html/parksavers_footer.html");

export const Footer: React.SFC<{}> = (props: {}) => {
    return  (<Row style={{marginTop: "35px"}}>
        <Col xs={0} lg={1}/>
        <Col xs={12} lg={10}><div /></Col>
        <Col xs={0} lg={1}/>
    </Row>);
};



// WEBPACK FOOTER //
// ./src/components/Header.tsx